import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/one-day-tms")({
  beforeLoad: () => {
    throw redirect({ to: "/ampa" });
  },
});
